import { SettoreDTO } from "@app/shared/dto/settoreDTO";

import { AutorizzazioneDTO } from "@app/shared/dto/autorizzazioneDTO";

export class ProfiloDTO {
  codice: string;

  nome: string;

  autorizzazioni: AutorizzazioneDTO[];

  settori: SettoreDTO[];
}
